import devhints from "../../../../assets/img/programming/devhints.webp";
import devdocs from "../../../../assets/img/programming/devdocs.webp";
import vue from "../../../../assets/img/programming/vue.webp";
import vuecomponents from "../../../../assets/img/programming/vuecomponents.webp";
import vuepress from "../../../../assets/img/programming/vuepress.webp";
import gridsome from "../../../../assets/img/programming/gridsome.webp";
import vuesion from "../../../../assets/img/programming/vuesion.webp";
import vueds from "../../../../assets/img/programming/vueds.webp";
import nuxt from "../../../../assets/img/programming/nuxt.webp";
import zeal from "../../../../assets/img/programming/zeal.webp";
import bitdev from "../../../../assets/img/programming/bitdev.webp";
import freefrontend from "../../../../assets/img/programming/freefrontend.webp";

export const DataDoc = [
  {
    title: "Devhints",
    path: "https://devhints.io/vue",
    icon: devhints,
    cName: "icon",
    description: "This is a collection of cheatsheets. Thanks to Rico.",
  },
  {
    title: "Devdocs",
    path: "https://devdocs.io/vue~2/",
    icon: devdocs,
    cName: "icon",
    description:
      "DevDocs combines multiple API documentations in a fast, organized, and searchable interface. It can be used Offline.",
  },
  {
    title: "Zeal",
    path: "https://zealdocs.org/",
    icon: zeal,
    cName: "icon",
    description:
      "Zeal is an offline documentation browser for software developers. Zeal comes with 200 awesome docsets.",
  },
  {
    title: "Vue (Official)",
    path: "https://vuejs.org/v2/guide/",
    icon: vue,
    cName: "icon",
    description: "The Official vue documentation.",
  },
];

export const DataComponents = [
  {
    title: "Vue Components",
    path: "https://vuecomponents.com/",
    icon: vuecomponents,
    cName: "icon",
    description: "The best website for finding and sharing Vue.js resources.",
  },
  {
    title: "Bit Dev",
    path: "https://bit.dev/",
    icon: bitdev,
    cName: "icon",
    description:
      "Bit is a scalable and collaborative way to build and reuse components. It's everything you need from local development to cross-project integrations.",
  },
  {
    title: "Vue Script",
    path: "https://www.vuescript.com/",
    icon: vue,
    cName: "icon",
    description:
      "VueScript.com aims to offer latest free Vue.js components for web application developers.",
  },
  {
    title: "Free Frontend",
    path: "https://freefrontend.com/react-code-examples/",
    icon: freefrontend,
    cName: "icon",
    description:
      "Free Vue code examples from codepen.io and github.io: buttons, modal windows, menu and other.",
  },
];

export const DataTools = [
  {
    title: "Vue Cli",
    path: "https://cli.vuejs.org/",
    icon: vue,
    cName: "icon",
    description: "Standard Tooling for Vue.js Development",
  },
];

export const DataLibrary = [
  {
    title: "VuePress",
    path: "https://v1.vuepress.vuejs.org/",
    icon: vuepress,
    cName: "icon",
    description: "Vue-powered Static Site Generator.",
  },
  {
    title: "Grid Some",
    path: "https://nitter.net/gridsome",
    icon: gridsome,
    cName: "icon",
    description:
      "Gridsome makes it easy for developers to build static generated websites & apps that are fast by default.",
  },
  {
    title: "Vuesion",
    path: "https://vuesion.herokuapp.com/",
    icon: vuesion,
    cName: "icon",
    description:
      "The most complete boilerplate for production-ready PWAs. With focus on performance, development speed, and best practices.",
  },
  {
    title: "Vueds",
    path: "https://vueds.com/",
    icon: vueds,
    cName: "icon",
    description:
      "Vue Design System provides you and your team a set of organized tools, patterns & practices. It works as the foundation for your application development.",
  },
  {
    title: "NuxtJS",
    path: "https://nuxtjs.org/",
    icon: nuxt,
    cName: "icon",
    description:
      "Build your next Vue.js application with confidence using NuxtJS. An open source framework making web development simple and powerful.",
  },
];
